<template>
  <div class="Contacts">
    <!-- 联系信息 -->
    <banner-section></banner-section>

    <section
      class="relative overflow-hidden from-primary to-pink-500 pt-20 md:pt-0 px-4"
    >
      <div class="container mx-auto px-[40px] mt-60">
        <div class="text-center">
          <h1 class="text-[#3d3d3d] text-6xl tracking-tight mb-2 text-sharp">
            CONTACT
          </h1>

          <!-- 辅助文本 -->
          <div class="text-[#858080] font-bold mb-8 tracking-wide text-sharp">
            <p>Get help from support,</p>
            <p>sales, or experts.</p>
          </div>
        </div>
        <!-- 表单开始 -->
        <form @submit.prevent="submitForm" class="space-y-6 mt-32">
          <!-- 两列布局：Name 和 Email -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label
                for="name"
                class="block text-sm font-medium text-gray-700 mb-1"
              >
                Name <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                v-model="formData.name"
                :class="{ 'border-red-500': errors.name }"
                class="rounded-md w-full px-4 py-2.5 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:border-transparent transition duration-200"
              />
              <p v-if="errors.name" class="mt-1 text-sm text-red-600">
                {{ errors.name }}
              </p>
            </div>

            <div>
              <label
                for="address"
                class="block text-sm font-medium text-gray-700 mb-1"
              >
                Email <span class="text-red-500">*</span>
              </label>
              <input
                type="email"
                id="address"
                v-model="formData.address"
                :class="{ 'border-red-500': errors.address }"
                class="rounded-md w-full px-4 py-2.5 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:border-transparent transition duration-200"
              />
              <p v-if="errors.address" class="mt-1 text-sm text-red-600">
                {{ errors.address }}
              </p>
            </div>
          </div>

          <!-- 两列布局：Product Name 和 Subject -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label
                for="productName"
                class="block text-sm font-medium text-gray-700 mb-1"
              >
                Product Name <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="productName"
                v-model="formData.productName"
                :class="{ 'border-red-500': errors.productName }"
                class="rounded-md w-full px-4 py-2.5 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:border-transparent transition duration-200"
              />
              <p v-if="errors.productName" class="mt-1 text-sm text-red-600">
                {{ errors.productName }}
              </p>
            </div>

            <div>
              <label
                for="subject"
                class="block text-sm font-medium text-gray-700 mb-1"
              >
                Subject <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="subject"
                v-model="formData.subject"
                :class="{ 'border-red-500': errors.subject }"
                class="rounded-md w-full px-4 py-2.5 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:border-transparent transition duration-200"
              />
              <p v-if="errors.subject" class="mt-1 text-sm text-red-600">
                {{ errors.subject }}
              </p>
            </div>
          </div>

          <!-- Leave a Message 多行文本输入框 -->
          <div>
            <label
              for="message"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Leave a Message <span class="text-red-500">*</span>
            </label>
            <textarea
              id="message"
              v-model="formData.message"
              rows="6"
              :class="{ 'border-red-500': errors.message }"
              class="rounded-md w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:border-transparent transition duration-200 resize-y"
            ></textarea>
            <div class="flex justify-between mt-1">
              <p v-if="errors.message" class="text-sm text-red-600">
                {{ errors.message }}
              </p>
              <p class="text-sm text-gray-500 ml-auto">
                {{ formData.message.length }}/1000
              </p>
            </div>
          </div>

          <!-- Submit 按钮 -->
          <div class="">
            <button
              type="submit"
              class="bg-[#d4335d] hover:bg-[#d4335d] text-white font-medium py-2 px-8 rounded-3xl focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:ring-offset-2 transition duration-200"
            >
              Submit
            </button>
          </div>

          <!-- 表单状态提示 -->
          <div
            v-if="submitStatus"
            class="mt-4 p-4 rounded-md"
            :class="
              submitStatus === 'success'
                ? 'bg-green-50 text-green-800'
                : 'bg-red-50 text-red-800'
            "
          >
            <div class="flex">
              <div class="flex-shrink-0">
                <svg
                  v-if="submitStatus === 'success'"
                  class="h-5 w-5 text-green-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clip-rule="evenodd"
                  />
                </svg>
                <svg
                  v-else
                  class="h-5 w-5 text-red-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div class="ml-3">
                <p class="text-sm">
                  {{
                    submitStatus === 'success'
                      ? 'Success. Thank you for your feedback.'
                      : 'Failed. Please check all required fields.'
                  }}
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>

    <!-- 公司位置地图 -->

    <section class="pt-16 bg-white">
      <div class="container mx-auto px-[40px]">
        <!-- <div class="mb-6">
          <h2 class="text-2xl font-bold text-gray-800">我们的位置</h2>
          <p class="text-gray-600 mt-1">欢迎到访我们的办公室</p>
        </div> -->

        <!-- 地图容器 -->
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14726.577927324295!2d113.2589762!3d22.6670402!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340236c610d02e33%3A0x77207191974acfb7!2z5Lit5Zu95bm_5Lic55yB5Lit5bGx5biC6I2j5Y2O5Y2X6LevMjnlj7cg6YKu5pS_57yW56CBOiA1Mjg0MTU!5e0!3m2!1sen!2sus!4v1769831158962!5m2!1sen!2sus"
          width="100%"
          height="450"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
          class="rounded-md bg-[#f5f5f5]"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>

        <!-- 公司地址信息 -->
        <!-- <div class="mt-6 p-4 bg-gray-50 rounded-lg">
          <h3 class="font-medium text-gray-800 mb-2">公司地址</h3>
          <div class="space-y-2 text-gray-600">
            <div class="flex items-start">
              <svg
                class="w-5 h-5 text-pink-500 mr-2 mt-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                ></path>
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                ></path>
              </svg>
              <p>上海市浦东新区张江高科技园区</p>
            </div>
            <div class="flex items-start">
              <svg
                class="w-5 h-5 text-pink-500 mr-2 mt-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                ></path>
              </svg>
              <p>+86 21 1234 5678</p>
            </div>
            <div class="flex items-start">
              <svg
                class="w-5 h-5 text-pink-500 mr-2 mt-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
              <p>周一至周五: 9:00 - 18:00</p>
            </div>
          </div>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
import bannerSection from '../index/bannerSection'
export default {
  name: 'Contacts',
  components: {
    bannerSection
  },
  data() {
    return {
      formData: {
        name: '',
        address: '',
        productName: '',
        subject: '',
        message: ''
      },
      errors: {
        name: '',
        address: '',
        productName: '',
        subject: '',
        message: ''
      },
      submitStatus: '' // 'success' 或 'error'
    }
  },
  methods: {
    validateForm() {
      // 重置错误信息
      this.resetErrors()

      let isValid = true

      // 验证Name
      if (!this.formData.name.trim()) {
        this.errors.name = 'This field is required'
        isValid = false
      }

      // 验证Email
      if (!this.formData.address.trim()) {
        this.errors.address = 'This field is required'
        isValid = false
      } else if (!this.isValidEmail(this.formData.address)) {
        this.errors.address = 'Please enter a valid email address.'
        isValid = false
      }

      // 验证Product Name
      if (!this.formData.productName.trim()) {
        this.errors.productName = 'This field is required'
        isValid = false
      }

      // 验证Subject
      if (!this.formData.subject.trim()) {
        this.errors.subject = 'This field is required'
        isValid = false
      }

      // 验证Message
      if (!this.formData.message.trim()) {
        this.errors.message = 'This field is required'
        isValid = false
      } else if (this.formData.message.length > 1000) {
        this.errors.message =
          'Der Inhalt der Nachricht darf 1000 Zeichen nicht überschreiten.'
        isValid = false
      }

      return isValid
    },
    isValidEmail(address) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(address)
    },

    resetErrors() {
      this.errors = {
        name: '',
        address: '',
        productName: '',
        subject: '',
        message: ''
      }
    },

    submitForm() {
      if (this.validateForm()) {
        // 模拟表单提交到服务器
        // console.log('表单数据:', JSON.stringify(this.formData))
        this.$api.sysApi
          .sendEmail(this.formData)
          .then((res) => {
            this.submitStatus = 'success'
            setTimeout(() => {
              this.resetForm()
              this.submitStatus = ''
            }, 3000)
          })
          .catch((err) => {
            console.log(err)
            this.submitStatus = 'error'
            setTimeout(() => {
              this.submitStatus = ''
            }, 2000)
          })
        //   // 显示成功消息
        //   this.submitStatus = 'success'

        //   // 3秒后重置表单和状态
        //   setTimeout(() => {
        //     this.resetForm()
        //     this.submitStatus = ''
        //   }, 3000)
        // } else {
        //   // 显示错误消息
        //   this.submitStatus = 'error'

        //   // 2秒后隐藏错误消息
        //   setTimeout(() => {
        //     this.submitStatus = ''
        //   }, 2000)
      }
    },

    resetForm() {
      this.formData = {
        name: '',
        address: '',
        productName: '',
        subject: '',
        message: ''
      }
      this.resetErrors()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-sharp {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

/* 地图 */
.map-section {
  margin-top: 40px;
}

#map {
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
}

.map-info {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  flex-wrap: wrap;
}

.map-detail {
  display: flex;
  align-items: center;
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  margin-right: 15px;
  margin-bottom: 15px;
  border-left: 3px solid #d32f2f;
}

.map-detail i {
  color: #d32f2f;
  margin-right: 10px;
  font-size: 1.2rem;
}

/* 工作时间 */
.hours-section {
  margin-top: 40px;
}

.hours-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}

.hours-table th,
.hours-table td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.hours-table th {
  background: #f8f9fa;
  color: #b71c1c;
  font-weight: 600;
}

.hours-table tr:last-child td {
  border-bottom: none;
}

.hours-table tr:hover {
  background: #fff5f5;
}

/* 紧急联系 */
.emergency-contact {
  background: linear-gradient(to right, #b71c1c, #d32f2f);
  color: white;
  padding: 30px;
  border-radius: 8px;
  margin-top: 40px;
  text-align: center;
}

.emergency-contact h3 {
  margin-bottom: 15px;
  font-size: 1.5rem;
}

.emergency-number {
  font-size: 2rem;
  font-weight: bold;
  margin: 15px 0;
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  padding: 10px 25px;
  border-radius: 30px;
}

.emergency-contact p {
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
}

#map {
  height: 400px;
  width: 100%;
  border-radius: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/page/contact/Contact.vue